<ng-container *ngIf="$vm | async as vm">
  <div class="wrapper--spacing-horizontal repeat-order-page">
    <div class="repeat-order-page__title">
      <h1 class="text--h1 repeat-order-page__title-text">
        {{ 'repeat-order-' + vm.prefix + '-page.title' | translate }}
      </h1>
      <button
        mat-flat-button
        color="accent"
        class="repeat-order-page__add-selected-items-to-cart"
        (click)="addSelectedItemsToCart(vm.cart, vm.selectedItems, vm.form)"
        [disabled]="!vm.selectedItems.length"
      >
        <mat-icon>add</mat-icon>
        <span>{{ 'repeat-order-' + vm.prefix + '-page.add-button' | translate: { count: '' + vm.selectedItems.length } }}</span>
      </button>
    </div>
    <p>
      {{ 'repeat-order-' + vm.prefix + '-page.subtitle' | translate }}
    </p>

    <agr-table-v2
      class="repeat-order-page__table"
      [dataSource]="vm.dataSource"
      [withSelection]="true"
      [isEqual]="isEquals"
      (selectionChanged)="onSelectionChanged($event)"
    >
      <ng-container *agrTableTopBar>
        <!-- Intentionally empty to remove the top bar -->
      </ng-container>

      <ng-container *agrTableFiltersWrapper>
        <!-- Intentionally empty to remove the clear filters button -->
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'repeat-order-' + vm.prefix + '-page.table-name' | translate }}
        </th>
        <td mat-cell [attr.aria-label]="'repeat-order-' + vm.prefix + '-page.table-name' | translate" *matCellDef="let row">
          <a
            #el
            href="#"
            (click)="selectRow($event, el)"
            class="text-color--info-500"
            [class]="row.isUserAllowedToOrderItem ? 'column-product-title' : 'column-product-title--disabled'"
          >
            {{ row.title }}<br />
          </a>
          <span class="text--label">
            {{ row.externalId }}
          </span>
          <div
            *ngIf="!row.isUserAllowedToOrderItem && { value: hasAtLeastAdvisorRole$ | async } as hasAtLeastAdvisorRole"
            class="column-product-title__isUserNotAllowedToOrderItem-info"
          >
            {{
              row.mappedToSkuCatalogItem
                | formatAddProductToCartButtonText: { hasAtLeastAdvisorRole: hasAtLeastAdvisorRole.value, useDefaultText: env.ALLOWED_ORDER_ROLES_DISABLED }
                | translate
            }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="data">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'repeat-order-' + vm.prefix + '-page.table-data' | translate }}
        </th>
        <td mat-cell [attr.aria-label]="'repeat-order-' + vm.prefix + '-page.table-data' | translate" *matCellDef="let row">
          {{ row.orderQuantity | agrNumber }} {{ 'unit.' + row.orderUnit | translate }}

          <ng-container *ngIf="row.lastUsedSilos?.length"> (Silo {{ getSiloIds(row) }}) </ng-container>
          <br />
          <span class="text--label">
            {{ row.latestOrder | agrDate: 'dd-MM-yyyy' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'repeat-order-' + vm.prefix + '-page.table-quantity' | translate }}
        </th>
        <td mat-cell [attr.aria-label]="'repeat-order-' + vm.prefix + '-page.table-quantity' | translate" *matCellDef="let row; let i = index">
          <div *ngIf="vm.form.at(i) as formGroup" class="column-quantity">
            <ng-container *ngIf="row.isUserAllowedToOrderItem">
              <mat-form-field
                floatLabel="auto"
                subscriptSizing="dynamic"
                appearance="fill"
                (click)="$event.stopPropagation()"
                class="full-width-field spacing--padding-right mat-form-field__no-spacing column-quantity__form-field"
              >
                <mat-label>{{ 'repeat-order-' + vm.prefix + '-page.table-quantity' | translate }}</mat-label>
                <input
                  matInput
                  agrNumber
                  [step]="row.orderingInformation?.increaseOrderUnitQuantity ?? 1"
                  [min]="row.orderingInformation?.minimumOrderUnitQuantity ?? 0"
                  [max]="row.orderingInformation?.maximumOrderUnitQuantity"
                  [formControl]="$any(formGroup.get('quantity'))"
                  [placeholder]="'repeat-order-' + vm.prefix + '-page.table-quantity' | translate"
                />
                <span
                  *ngIf="row.orderingInformation?.orderUnit"
                  matIconSuffix
                  data-test="table-desktop__input-number-suffix"
                  [attr.data-translate-key]="row.orderingInformation?.orderUnit"
                >
                  {{ 'unit.' + row.orderingInformation.orderUnit | translate }}
                </span>
              </mat-form-field>
            </ng-container>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="siloDistribution">
        <th mat-header-cell *matHeaderCellDef class="spacing--padding-left spacing--padding-right">
          {{ 'repeat-order-' + vm.prefix + '-page.table-silo' | translate }}
        </th>
        <td
          mat-cell
          *matCellDef="let row; let i = index"
          class="spacing--padding-left spacing--padding-right"
          [attr.aria-label]="'repeat-order-' + vm.prefix + '-page.table-silo' | translate"
        >
          <ng-container *ngIf="row.isUserAllowedToOrderItem">
            <div class="column-silo-distribution flex--row">
              <div class="column-silo-distribution__button-wrapper">
                <button mat-button class="repeat-order-edit-button" data-test="repeat-order-open-silo-distribution" (click)="openSiloDistributionDialog(row)">
                  <mat-icon>{{ row.silos?.length ? 'edit' : 'add' }}</mat-icon>
                  <span *ngIf="!row.silos?.length">
                    {{ 'silos.select-silo' | translate }}
                  </span>
                </button>
              </div>

              <div *ngIf="row.silos?.length" class="silo-information-wrapper flex--column">
                <div *ngFor="let silo of row.silos" class="silo-information flex__child flex--row">
                  <div>Silo {{ silo.siloNumber }}</div>
                  <div class="silo-information__quantity flex__child text--gray" [ngClass]="{ error: vm.form.at(i).errors?.invalidSiloDistribution }">
                    {{
                      silo.distributionType !== 'Exact'
                        ? ('silos.silo-' + silo.distributionType | translate)
                        : (silo.quantity | agrNumber) + ('unit.' + row.orderingInformation?.orderUnit | translate)
                    }}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="deliveryInformation">
        <th mat-header-cell *matHeaderCellDef class="spacing--padding-left">
          {{ 'repeat-order-' + vm.prefix + '-page.table-delivery-date' | translate }}
        </th>
        <td
          mat-cell
          [attr.aria-label]="'repeat-order-' + vm.prefix + '-page.table-delivery-date' | translate"
          *matCellDef="let row; let i = index"
          class="spacing--padding-left"
        >
          <ng-container *ngIf="row.isUserAllowedToOrderItem">
            <div class="column-delivery-information flex--column" *ngIf="vm.form.at(i) as formGroup">
              <div class="column-delivery-information__button-wrapper">
                <button
                  mat-button
                  class="repeat-order-delivery-button"
                  [class.repeat-order-delivery-button--no-date]="!formGroup.get('deliveryInformation').value"
                  data-test="repeat-order-open-delivery-date"
                  (click)="openDeliveryDateDialog(row, $any(formGroup))"
                >
                  <ng-container *ngIf="formGroup.get('deliveryInformation').value === null; else editDeliveryDate">
                    <mat-icon>add</mat-icon>
                  </ng-container>
                  <ng-template #editDeliveryDate>
                    <mat-icon>edit</mat-icon>
                    <span>{{ formGroup.get('deliveryInformation').value.deliveryDate | agrDate }}</span>
                  </ng-template>
                </button>
              </div>
              <div class="text--label repeat-order-page__delivery-text" *ngIf="row?.deliveryInformation | formatFlexibilityDate as minimumDate">
                {{ minimumDate }} -
                {{ formGroup.get('deliveryInformation').value.deliveryDate | agrDate }}
              </div>
            </div>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="palletInformation">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'repeat-order-' + vm.prefix + '-page.table-pallet' | translate }}
        </th>
        <td mat-cell [attr.aria-label]="'repeat-order-' + vm.prefix + '-page.table-pallet' | translate" *matCellDef="let row">
          <span class="text--label">
            {{ row.orderingInformation?.palletOrderUnitQuantity > 1 ? row.orderingInformation?.palletOrderUnitQuantity : '-' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="favoriteStar">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row; let i = index">
          <app-favorites-star *ngIf="isFavoritesEnabled" class="favorite-star" [skuId]="row.internalId"></app-favorites-star>
        </td>
      </ng-container>

      <ng-container matColumnDef="addSingleItemToCart">
        <th mat-header-cell *matHeaderCellDef></th>
        <td class="add-single-item-to-cart spacing--padding-left" mat-cell *matCellDef="let row; let i = index">
          <ng-container *ngIf="vm.form.at(i) as formGroup">
            <ng-container *ngIf="row.isUserAllowedToOrderItem">
              <button
                class="add-single-item-to-cart__button"
                color="primary"
                mat-flat-button
                [disabled]="formGroup.invalid || !row.isUserAllowedToOrderItem"
                (click)="addSingleItemToCart(vm.cart, row, vm.form)"
              >
                <mat-icon class="add-single-item-to-cart__icon">add_shopping_cart</mat-icon>
              </button>
            </ng-container>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="vm.columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let _; columns: vm.columnsToDisplay"></tr>
    </agr-table-v2>
  </div>
</ng-container>
